import { Checkbox } from "primereact/checkbox";
import { Controller } from "react-hook-form";
import styles from "./style.module.scss";

const FormCheckbox = ({ name, label, control, required, disabled }) => (
    <div className={`p-d-flex p-ai-center ${styles.checkboxContainer}`}>
        <Controller
            name={name}
            control={control}
            render={({field}) => (
                <Checkbox
                    inputId="activity"
                    checked={!!field.value}
                    onChange={(e) => field.onChange(e.checked)}
                    required={required}
                    disabled={disabled}
                />
            )}
        />
        <label className={styles.checkboxLabel} htmlFor="activity">
            {label}
        </label>
    </div>
);

export default FormCheckbox;